document.addEventListener("BSS:changeVariantQV", e => {
  setTimeout(() => {
    const productForm = document.querySelector("[bss-b2b-quickview-product-form]");
    BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', { productForm });
  }, 500);
});

document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (e) {
    const quickViewBtn = e.target.closest('[bss-b2b-btn-quickview]');
    if (quickViewBtn) {
      setTimeout(() => {
        document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
      }, 1000);
    }
  });

  if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const target = document.querySelector('search-drawer');
    if (!target) return;

    const observer = new MutationObserver((mutations) => {
      for (let mutation of mutations) {
        if (mutation.attributeName === "results") {
          const isResults = target.hasAttribute("results");

          if (isResults) {
            window.dispatchEvent(new Event("scroll"));
          }
        }
      }
    });

    observer.observe(target, {
      attributes: true,
      attributeFilter: ["results"]
    });
  }, 300);
}
});


